import React, { useCallback, useEffect, useState } from 'react';
import styles from './Modal.module.scss';
import usePortal from 'react-useportal';

const Modal = (props) => {
    const { className = '', title, header, children, footer, onClose, show = true, fullHeight = false, fullScreen = true } = props,
        [visible, setVisible] = useState(false),
        { Portal } = usePortal();

    useEffect(() => {
        setVisible(show);
    }, [show]);

    const handleClose = useCallback(() => {
        setTimeout(onClose, 300);
        setVisible(false);
    }, [onClose]);

    return (
        <Portal>
            <div className={[className, styles.modal, visible ? styles.show : styles.hide, fullScreen ? styles.fullScreen : ''].join(' ')}>
                <div className={[styles.overlay, visible ? styles.show : styles.hide, fullScreen ? styles.fullScreen : ''].join(' ')} onClick={handleClose}></div>
                <div className={[styles.dialog, visible ? styles.show : styles.hide, fullHeight ? styles.fullHeight : '', fullScreen ? styles.fullScreen : ''].join(' ')}>
                    <div className={styles.header}>
                        <button type="button" className={styles.close} onClick={handleClose} />
                        {title ? <h2 className={styles.title}>{title}</h2> : null}
                        {header}
                    </div>
                    <div className={styles.body}>{children}</div>
                    {footer ? <div className={styles.footer}>{footer}</div> : null}
                </div>
            </div>
        </Portal>
    );
};

export default Modal;
